<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <ul :class="$style.list">
      <li
        v-for="entry in childData?.data"
      >
        <SharedThumbnailExhibitionComponent
          :data="entry"
        />
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

</script>

<style module lang=scss>
.root {
  position: relative;
}

.list {
  composes: reset-list from global;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: var(--unit--horizontal);
  grid-row-gap: calc(var(--unit--vertical) * 2);

  padding-left: var(--unit--horizontal);
  padding-right: var(--unit--horizontal);

  @media (max-width: $breakpoint-m) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $breakpoint-s) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.list li {
  width: 100%;
  overflow: hidden;
}
</style>
